module.exports = __webpack_public_path__ + "static/media/8.fbe8666d.jpg";